/**
 * Shared utilities for building upgrade validation.
 */

import { BuildingType } from '@shared/constants/buildings';

/**
 * Check if a building can be upgraded based on its current level and the upgrade system.
 * 
 * @param buildingType The type of building
 * @param currentLevel The current level of the building
 * @param upgradeSystem The upgrade system (optional, for checking max level)
 * @returns true if the building can be upgraded, false otherwise
 */
export function canUpgradeBuilding(
  buildingType: BuildingType,
  currentLevel: number,
  upgradeSystem?: {
    getMaxLevel: (buildingType: BuildingType) => number;
  } | null
): boolean {
  if (upgradeSystem) {
    const maxLevel = upgradeSystem.getMaxLevel(buildingType);
    return currentLevel < maxLevel;
  }
  
  // Fallback: cap towers at 4, other buildings at 10
  // This is a conservative fallback if upgrade system is not available
  const maxLevel = buildingType === BuildingType.MINE ? 10 : 4;
  return currentLevel < maxLevel;
}

